import Swiper, { Navigation, Autoplay } from "swiper";
Swiper.use([Navigation, Autoplay]);

import { gsap } from "gsap/dist/gsap"; // 最小限の GSAP を読み込む
import { ScrollTrigger } from "gsap/dist/ScrollTrigger"; // ScrollTrigger のみ個別インポート

gsap.registerPlugin(ScrollTrigger);

export function aboutFunc() {
  //志、代表メッセージ
  // モノクロからカラーに変化
  gsap.to(".hero__bg", {
    filter: "grayscale(0%)",
    duration: 0.15,
    delay: 0.7,
    ease: "power2.out",
  });

  // タイトルフェードイン
  // gsap.to(".hero__title", {
  //   opacity: 1,
  //   delay: 0.5,
  //   duration: 0.5,
  // });

  // `hero__bg` をスクロールで固定する
  gsap.set(".hero__bg", { position: "fixed", top: 0, left: 0, width: "100%" });

  // `hero__bg` の固定を解除する（メインビジュアルが終わったら）
  ScrollTrigger.create({
    trigger: ".vision-sec--gifun",
    start: "top top", // `.main-content` が画面の最上部に来たら発火
    onEnter: () =>
      gsap.set(".hero__bg", { position: "absolute", top: "auto", bottom: "0" }),
    onLeaveBack: () =>
      gsap.set(".hero__bg", {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
      }), // 逆スクロール時に再び固定
  });

  // スクロールでテキストが下から表示
  // gsap.utils.toArray(".fade-up").forEach((element) => {
  //   gsap.to(element, {
  //     opacity: 1,
  //     y: 0,
  //     duration: 1.2,
  //     ease: "power2.out",
  //     scrollTrigger: {
  //       trigger: element,
  //       start: "top 85%",
  //       end: "top 50%",
  //       scrub: false,
  //     },
  //   });
  // });

  function restartGif(imgElement) {
    const src = imgElement.src;
    imgElement.src = "";
    imgElement.src = src;
  }

  document.querySelectorAll(".overlay-sec--vision").forEach((section) => {
    const imgWrap = section.querySelector(".overlay-sec__img-wrap");
    const overlay = section.querySelector(".overlay-sec__overlay");
    const content = section.querySelector(".overlay-sec__content");
    const obj = section.querySelectorAll(".obj-fadein");
    const texts = section.querySelectorAll(".text-fadein");

    // 背景画像の pin（固定）
    ScrollTrigger.create({
      trigger: section,
      start: "top top",
      endTrigger: content,
      end: "bottom bottom",
      pin: imgWrap,
      pinSpacing: false,
      anticipatePin: 1,
    });

    // オーバーレイ → テキスト（重なった状態で表示）
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: "top 80%",
        once: true,
      },
    });

    tl.to(overlay, {
      backgroundColor: "rgba(0, 0, 0, 0.4)",
      duration: 1.0,
      ease: "power2.out",
    })
      .to(content, {
        opacity: 1,
        // y: 0,
        duration: 0.5,
        ease: "power2.out",
      })
      .to(
        obj,
        {
          opacity: 1,
          y: 0,
          duration: 0.5,
          stagger: 0.2,
          ease: "power2.out",
        },
        "<"
      )
      .to(
        texts,
        {
          opacity: 1,
          y: 0,
          duration: 0.5,
          stagger: 0.2,
          ease: "power2.out",
        },
        "<"
      )
      .call(() => {
        const isSP = window.innerWidth <= 750;

        if (isSP) {
          // 👇 スマホは即実行
          // const gifs = section.querySelectorAll(".overlay-sec__gif");

          // gifs.forEach((wrap) => {
          //   // .girl（video）の場合
          //   const video = wrap.querySelector("video");
          //   if (wrap.classList.contains("girl") && video) {
          //     video.currentTime = 0;
          //     video.play();
          //     gsap.to(video, {
          //       opacity: 1,
          //       duration: 0.6,
          //       ease: "power2.out",
          //     });
          //     return;
          //   }

          //   // .flash（img）の場合
          //   const img = wrap.querySelector("img");
          //   if (img) {
          //     gsap.to(img, {
          //       opacity: 1,
          //       duration: 0.6,
          //       ease: "power2.out",
          //     });

          //     const src = img.src;
          //     img.src = "";
          //     img.src = src;
          //   }
          // });

          ScrollTrigger.create({
            trigger: section,
            start: "top 80%",
            end: "bottom top",
            onEnter: () => {
                playMedia(section); // 2回目以降は即再生
            },
            onEnterBack: () => {
                playMedia(section); // 戻ってきたときも再生
            },
            onLeave: () => {
              stopMedia(section);
            },
            onLeaveBack: () => {
              stopMedia(section);
            },
          });

        } else {
          // 👇 PCはスクロール検知してから
          const scrollContainer = section.querySelector(
            ".overlay-sec__content"
          );
          let alreadyPlayed = false;

          const maxScroll =
            scrollContainer.scrollHeight - scrollContainer.clientHeight;

          const onScroll = () => {
            const scrollTop = scrollContainer.scrollTop;

            // if (!alreadyPlayed && Math.abs(scrollTop - maxScroll) < 1) {
            if (!alreadyPlayed && scrollTop > 0) {
              alreadyPlayed = true;
              playMedia(section);
              ScrollTrigger.refresh();
            }

            // if (Math.abs(scrollTop - maxScroll) < 1) {
            //   const gifs = section.querySelectorAll(".overlay-sec__gif");

            //   gifs.forEach((wrap) => {
            //     // .girl
            //     const video = wrap.querySelector("video");
            //     if (wrap.classList.contains("girl") && video) {
            //       video.currentTime = 0;
            //       video.play();
            //       gsap.to(video, {
            //         opacity: 1,
            //         duration: 0.6,
            //         ease: "power2.out",
            //       });
            //       return;
            //     }
            //     // 光
            //     const img = wrap.querySelector("img");
            //     if (img) {
            //       gsap.to(img, {
            //         opacity: 1,
            //         duration: 0.6,
            //         ease: "power2.out",
            //       });
            //       const src = img.src;
            //       img.src = "";
            //       img.src = src;
            //     }
            //   });

            //   scrollContainer.removeEventListener("scroll", onScroll);
            // }
          };

          scrollContainer.addEventListener("scroll", onScroll);

          ScrollTrigger.create({
            trigger: section,
            start: "top 80%",
            end: "bottom top",
            onEnter: () => {
              if (alreadyPlayed) {
                playMedia(section); // 2回目以降は即再生
              }
            },
            onEnterBack: () => {
              if (alreadyPlayed) {
                playMedia(section); // 戻ってきたときも再生
              }
            },
            onLeave: () => {
              stopMedia(section);
            },
            onLeaveBack: () => {
              stopMedia(section);
            },
          });
        }
      });

      function playMedia(section) {
        const gifs = section.querySelectorAll(".overlay-sec__gif");

        gifs.forEach((wrap) => {
          const video = wrap.querySelector("video");
          // const img = wrap.querySelector("img");

          if (video) {
            video.currentTime = 0;
            video.play();
            gsap.to(video, { opacity: 1, duration: 0.6 });
          }

          // if (img) {
          //   const src = img.src;
          //   img.src = "";
          //   img.src = src;
          //   gsap.to(img, { opacity: 1, duration: 0.6 });
          // }
        });
      }

      function stopMedia(section) {
        const gifs = section.querySelectorAll(".overlay-sec__gif");

      gifs.forEach((wrap) => {
        const video = wrap.querySelector("video");
        // const img = wrap.querySelector("img");

        if (video) {
          video.pause();
          video.currentTime = 0;

          gsap.to(video, {
            opacity: 1,
            duration: 0.6,
            ease: "power2.out",
          });
        }

        // if (img) {
        //   gsap.to(img, {
        //     opacity: 0,
        //     duration: 0.6,
        //     ease: "power2.out",
        //   });
        // }
      });
    }
  });

  document.querySelectorAll(".overlay-sec--message").forEach((section) => {
    const imgWrap = section.querySelector(".overlay-sec__img-wrap");
    const overlay = section.querySelector(".overlay-sec__overlay");
    const content = section.querySelector(".overlay-sec__content");
    // const obj = section.querySelectorAll(".obj-fadein");
    // const texts = section.querySelectorAll(".text-fadein");

    // 背景画像の pin（固定）
    ScrollTrigger.create({
      trigger: section,
      start: "top top",
      endTrigger: content,
      end: "bottom bottom",
      pin: imgWrap,
      pinSpacing: false,
      anticipatePin: 1,
    });
  });

  //テキストフェードイン
  gsap.utils.toArray(".text-fadein02").forEach((element) => {
    gsap.to(element, {
      opacity: 1,
      // y: 0, // 下から 0 に戻す
      duration: 1.2,
      ease: "power2.out",
      scrollTrigger: {
        trigger: element,
        start: "top 90%", // 画面の80%の位置で開始
        toggleActions: "play none none reverse", // 逆スクロールで消える
      },
    });
  });
  //オブジェクトフェードイン（テキストよりちょっと早い）
  gsap.utils.toArray(".obj-fadein02").forEach((element) => {
    gsap.to(element, {
      opacity: 1,
      y: 0, // 下から 0 に戻す
      duration: 0.8,
      ease: "power2.out",
      scrollTrigger: {
        trigger: element,
        start: "top 80%", // 画面の80%の位置で開始
        toggleActions: "play none none reverse", // 逆スクロールで消える
      },
    });
  });

  // ScrollTrigger.create({
  //   trigger: ".vision-sec--gifun",
  //   start: "top top",
  //   end: () => "+=" + document.querySelector(".vision-sec--gifun .overlay-sec__content").offsetHeight + "px",
  //   pin: ".vision-sec--gifun .overlay-sec__img-wrap",
  //   anticipatePin: 1,
  //   onEnter: () => {
  //     gsap.to(".vision-sec--gifun .overlay-sec__overlay", {
  //       backgroundColor: "rgba(0, 0, 0, 0.4)",
  //       duration: 1.5,
  //       ease: "power2.out"
  //     });

  //     gsap.to(".vision-sec--gifun .obj-fadein", {
  //       opacity: 1,
  //       y: 0,
  //       duration: 0.8,
  //       stagger: 0.2,
  //       ease: "power2.out"
  //     });
  //     gsap.to(".vision-sec--gifun .text-fadein", {
  //       opacity: 1,
  //       y: 0,
  //       duration: 1.2,
  //       stagger: 0.2,
  //       ease: "power2.out"
  //     });
  //   }
  // });

  //オーバーレイを濃くする
  // gsap.to(".vision-sec--gifun .overlay-sec__overlay", {
  //   background: "rgba(0, 0, 0, 0.5)", // 黒のオーバーレイを濃くする
  //   duration: 1.5,
  //   ease: "power2.out",
  //   scrollTrigger: {
  //     trigger: ".vision-sec--gifun", // セクション全体をトリガーにする
  //     start: "top 10%", // 画面の中央付近に来たら開始
  //     end: "top -10%", // さらにスクロールすると終了
  //     scrub: true, // スクロールに合わせて変化
  //   },
  // });

  // gsap.to(".vision-sec--shinnen .overlay-sec__overlay", {
  //   background: "rgba(0, 0, 0, 0.5)", // 黒のオーバーレイを濃くする
  //   duration: 1.5,
  //   ease: "power2.out",
  //   scrollTrigger: {
  //     trigger: ".vision-sec--shinnen",
  //     start: "top 10%",
  //     end: "top -10%",
  //     scrub: true,
  //   },
  // });

  // gsap.to(".message-sec--01 .overlay-sec__overlay", {
  //   background: "rgba(0, 0, 0, 0.5)",
  //   duration: 1.5,
  //   ease: "power2.out",
  //   scrollTrigger: {
  //     trigger: ".message-sec--01",
  //     start: "top 10%",
  //     end: "top -10%",
  //     scrub: true,
  //   },
  // });

  // gsap.to(".message-sec--02 .overlay-sec__overlay", {
  //   background: "rgba(0, 0, 0, 0.5)",
  //   duration: 1.5,
  //   ease: "power2.out",
  //   scrollTrigger: {
  //     trigger: ".message-sec--02",
  //     start: "top 10%",
  //     end: "top -10%",
  //     scrub: true,
  //   },
  // });

  // gsap.to(".message-sec--03 .overlay-sec__overlay", {
  //   background: "rgba(0, 0, 0, 0.5)",
  //   duration: 1.5,
  //   ease: "power2.out",
  //   scrollTrigger: {
  //     trigger: ".message-sec--03",
  //     start: "top 10%",
  //     end: "top -10%",
  //     scrub: true,
  //   },
  // });

  // gsap.to(".message-sec--04 .overlay-sec__overlay", {
  //   background: "rgba(0, 0, 0, 0.5)",
  //   duration: 1.5,
  //   ease: "power2.out",
  //   scrollTrigger: {
  //     trigger: ".message-sec--04",
  //     start: "top 10%",
  //     end: "top -10%",
  //     scrub: true,
  //   },
  // });

  // document.querySelectorAll(".overlay-sec").forEach((section) => {
  //   const imgWrap = section.querySelector(".overlay-sec__img-wrap");
  //   const content = section.querySelector(".overlay-sec__content");

  //   ScrollTrigger.create({
  //     trigger: section,
  //     start: "top top",
  //     endTrigger: content,
  //     end: "bottom top",
  //     pin: imgWrap,
  //     pinSpacing: false,
  //   });
  // });

  // 神輿
  const isPC = window.matchMedia("(min-width: 750px)").matches;
  const animationProps = isPC
    ? { x: "40vw", y: "-250px", duration: 4 } // PC用
    : { x: "54vw", y: "-10px", duration: 2 }; // SP用
  gsap.from(".mikoshi", {
    ...animationProps,
    ease: "steps(100)",
    scrollTrigger: {
      trigger: ".mikoshi",
      start: "top 80%",
      markers: false,
    },
    onStart: () => {
      document.querySelector(".mikoshi")?.classList.add("is-animating");
    },
  });
}
